import React from "react";
import { Col, Row } from "react-bootstrap";
import ClipLoader from "react-spinners/ClipLoader";

const CustomLoader: React.FC = () => {
  return (
    <Row
      className="w-100 d-flex justify-content-center align-items-center"
      style={{ height: "20vh" }}
    >
      <Col className="text-center">
        <ClipLoader color="#000080" />
      </Col>
    </Row>
  );
};

export default CustomLoader;
